import * as React from 'react';
import {authorize, IWithRouterProps, Overlay, withRouter} from "@athena-portal/components";
import {lazyInject} from "@athena-portal/core";
import {
    FalconPaymentRequest,
    VerifyNewCardResponse
} from "@ferry/journey-services";
import {PluginTemplates} from "../../../../utils/PluginTemplates";
import FalconHeader from "../../../../components/navigation/FalconHeader";
import {Navigate} from "react-router-dom";
import {getAmountWithDecimalDigits, getSessionStorage} from "../../../../CommonFunctions";
import {Types} from "../../../../Types";
import type {ICustomerPortalService} from "../../../../services/ICustomerPortalService";
import {getBrandFromPolicyNumber, resourcesHelper, Footer} from "@ferry/portal-core";

interface IParams {
    policyNumber: string;
    paymentReference: string;
    [key: string]: string | undefined
}

interface IState {
    paymentSuccess: boolean;
    paymentCancelled: boolean;
    cardVerified: boolean;
    paymentAmountReceived: boolean;
    settings: any,
}

@authorize
export class CardPaymentProcessingPagePlain extends React.Component<IWithRouterProps<IParams>, IState> {

    private pluginTemplates = new PluginTemplates();

    @lazyInject(Types.CustomerPortalService)
    private customerPortalService: ICustomerPortalService;

    constructor(props: IWithRouterProps<IParams>) {
        super(props);

        this.state = {
            paymentSuccess: false,
            paymentCancelled: false,
            cardVerified: false,
            settings: getSessionStorage("paymentSettings"),
            paymentAmountReceived: false
        };

        this.newCardPaymentVerify = this.newCardPaymentVerify.bind(this);
        this.verificationNeeded = this.verificationNeeded.bind(this);
    }

    public componentDidMount() {
        this.pluginTemplates.setPageTitle("Payment processing");

        if (this.verificationNeeded()) {
            this.newCardPaymentVerify(this.props.params.paymentReference);
        }
    }

    public render() {
        const {
            paymentSuccess,
            paymentCancelled,
            cardVerified
        } = this.state;

        const brandName: string = this.props.params.policyNumber ?
            getBrandFromPolicyNumber(this.props.params.policyNumber)! :
            resourcesHelper.THEME_NAME;

        if (cardVerified) {
            if (!paymentSuccess && !paymentCancelled) {
                return <Navigate to={{pathname: `/dashboard/account/newCardPayment/${this.props.params.policyNumber}`}}
                                 state={{ verifyCardFailed: true }}
                />
            } else {

                const redirectUrl: string = this.state.settings.returnUrl

                if (paymentSuccess) {
                    window.sessionStorage.setItem("showPopup", "true");
                    this.customerPortalService.getSettledAmountByPaymentReference(this.props.params.policyNumber, this.props.params.paymentReference).subscribe((amount: number) => {
                        window.sessionStorage.setItem("paymentAmount", getAmountWithDecimalDigits(amount).toString());
                        this.setState({paymentAmountReceived:true});
                    });
                    if (this.state.paymentAmountReceived) {
                        return <Navigate to={redirectUrl} />
                    }
                } else {
                    return <Navigate to={redirectUrl} />
                }
            }
        }

        return (
            <React.Fragment>
                <Overlay show={true} />
                <FalconHeader/>
                <div className="panel panel-processing">
                    <span className="loading-animation"></span>
                    <h1 className="panel-heading">Processing...</h1>
                    <h2 className="text-center h5">Once your {brandName} insurance is set up, you will see a payment confirmation screen and you will receive a confirmation email.</h2>
                    <p>Please wait...</p>
                    <p>Don't refresh or close your browser...</p>
                    <img className="car" src="/img/Flourishes-5.svg"/>
                </div>
                <Footer/>
            </React.Fragment>
        )
    }

    private newCardPaymentVerify(paymentReference: string): void {
        const request: FalconPaymentRequest = new FalconPaymentRequest();
        request.invoiceType = this.state.settings.invoiceType;
        this.customerPortalService.newCardPaymentVerify(request, paymentReference).subscribe((response: VerifyNewCardResponse) => {
            this.setState({
                paymentSuccess: response && response.successful,
                paymentCancelled: response && response.cancelled,
                cardVerified: true
            });
        });
    }

    private verificationNeeded(): boolean {
        return this.props.params.paymentReference != null;
    }
}

export const CardPaymentProcessingPage = withRouter<{}, IParams>(CardPaymentProcessingPagePlain)
